/* PWA 「홈 화면에 추가」 설치 배너 + Service Worker 등록 — 외부화본 (2026-08-07)
 *
 * 원래 src/lib/design-system.ts 의 pwaInstallBannerScript() 가 돌려주던 인라인 <script>(24,582 B)다.
 * ★근로자·회사 관리·플랫폼·로그인 — 전 포털 전 화면에 매번 실렸다.★
 * 화면 하나 열 때마다 같은 24 KB 를 다시 받고 다시 파싱·컴파일했다(인라인은 HTTP 캐시도
 * V8 코드 캐시도 못 탄다). 근로자 홈 인라인 상한(200,000 B)을 지키기 위한 이동이기도 하다.
 * ★상한을 올려서 통과시키지 않고 실제로 줄였다.★
 *
 * 담고 있는 것:
 *   - 플랫폼 감지(iOS Safari / Android Chrome / 카카오·네이버·인스타·페북·라인 인앱)
 *   - beforeinstallprompt 캡처 → 네이티브 설치 프롬프트, iOS 는 수동 안내
 *   - Service Worker 등록 + 배포 버전 변경 감지
 *   - 7일 dismiss 기억(localStorage), standalone 실행 중이면 미표시
 *
 * ★서버 값은 이 파일에 없다.★ 유일한 서버 값(자동 새로고침 허용 여부)은 바로 앞의
 * 작은 인라인 <script> 가 window.__INS_PWA_AUTO_RELOAD 로 넘긴다 —
 * 정적 파일에 박으면 1년 immutable 캐시가 ★다른 화면의 값★ 을 준다
 * (플랫폼 관리자 화면만 자동 새로고침을 끈다).
 *
 * 주의 1: ★근로자·플랫폼 셸에서만★ defer/async 금지(원래 인라인이 그 자리에서 동기 실행) — ★관리자 셸은 defer★(계약 admin-shell-render-blocking 의 사유 표가 정본).
 *         🚫 근로자 셸을 defer 로 옮기지 마라(V2-B 실측 2026-09-19): RUM dom = DCL − responseEnd 라 이득 0 이고, 파싱 시점 계약(D6 네이티브 브리지)이 깨진다.
 * 주의 2: 서버 보간 문법을 절대 넣지 말 것 — 정적 파일이라 그대로 사용자에게 노출된다.
 * 주의 3: 정규식의 역슬래시는 ★파일 기준★ 이다. TS 템플릿 리터럴로 되돌릴 때는
 *         `\s` → `\\s` 처럼 다시 이스케이프해야 한다(반대로 하면 Invalid regular expression).
 */
(function(){
  if (window.__insacheckA2HS) return; window.__insacheckA2HS = 1;
  /* 자동 새로고침 허용 여부 — 바로 앞 인라인 <script> 가 넘겨준다.
     ★정적 파일에 박으면 1년 캐시가 다른 화면의 값을 준다★(플랫폼 관리자만 false). */
  var allowAutomaticReload = window.__INS_PWA_AUTO_RELOAD !== false;
  var CLIENT_COMPAT_EPOCH = 1; function compatQuiet(j){ return !!j && typeof j.compat === 'number' && j.compat === CLIENT_COMPAT_EPOCH; }   /* ★호환 세대(S-04)★ 정본 src/lib/client-compat.ts 사본(계약이 잠근다 · 🚫 따로 고치지 마라) — /api/build compat 이 같으면 새 빌드는 다음 전체 이동 때 · 다르거나 없으면 강제(안전 기본) */
  // ─── 플랫폼 감지 (전역 — auto 배너 + 수동 트리거 둘 다 사용) ───
  var ua = navigator.userAgent || '';
  var isIOS = /iPhone|iPad|iPod/i.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
  var isAndroid = /Android/i.test(ua);
  var isMobile = isIOS || isAndroid;
  var isKakao = /KAKAOTALK/i.test(ua);
  var isNaver = /NAVER\(inapp/i.test(ua) || (/NAVER /i.test(ua) && /inapp/i.test(ua));
  var isInsta = /Instagram/i.test(ua);
  var isFB = /FBAN|FBAV/i.test(ua);
  var isLine = /Line\//i.test(ua);
  var isInApp = isKakao || isNaver || isInsta || isFB || isLine;

  /* 인사책 Flutter 앱(WebView) 여부 — app_client=1 쿠키(webview_screen.dart _bootstrap 이 심음)
     + Android WebView UA 마커 '; wv)'. 서버 isAppClient(auth.ts) / isAppWebView(worker.ts) 와
     동일 판정 규칙. 소셜 인앱브라우저 감지인 isInApp 과는 별개 — 앱은 설치 배너 자체가 무의미. */
  var isNativeApp =
    /(?:^|;\s*)app_client=1(?:;|$)/.test(document.cookie || '') || /;\s*wv\)/.test(ua);

  /* 인사책 데스크톱 앱(Electron) 여부 — preload 브리지 우선, UA 토큰 폴백.
     판정 규칙은 app-dialogs.js 의 __insIsDesktopApp / 서버 isDesktopUserAgent 와 같다.
     ⚠ 이 파일은 app-dialogs.js 보다 먼저 실행될 수 있어 그 전역에 의존하지 않고
       같은 규칙을 자체 판정한다(정적 파일이라 보간(${) 금지 규칙도 그대로 지킨다). */
  var isDesktopApp =
    !!window.insacheckDesktop || ua.indexOf('InsacheckDesktop/') >= 0;

  /* ★강제 리로드를 하면 안 되는 「임베디드 앱」 축★ (2026-08-13 신설).
     Flutter WebView 와 Electron 데스크톱 앱을 함께 묶는다 — 둘 다 브라우저 탭이
     아니라 ★앱★ 이고, 사용자가 오래 띄워 둔 화면을 배포 때문에 갈아엎으면 안 된다.
     데스크톱은 특히 트레이 상주(desktop/src/main.ts: 닫기 = win.hide())라 체류가 길고,
     자체 업데이터가 이미 「강제 재시작 없음」 계약을 갖는다
     (desktop/src/updater.ts: autoInstallOnAppQuit = true).
     ⚠ isNativeApp 에 데스크톱을 섞지 말 것 — 그 변수는 "Flutter WebView 인가"라는
       구체적 뜻으로 다른 곳에서도 쓰인다(이름이 거짓말이 된다). */
  var isEmbeddedApp = isNativeApp || isDesktopApp;

  /* v45 fix (사용자: "앱으로 설치 버튼 누르면 가이드라인만 나오고"):
     beforeinstallprompt 리스너를 IIFE 최상단에 무조건 먼저 등록.
     이전: 리스너가 IIFE 후반(SW 등록 블록 뒤)에 있어서, SW 블록이 throw 하면
           리스너 등록 자체가 skip → deferredPrompt 영영 null → 버튼이 가이드라인 fallback.
     이후: 어떤 코드가 실패해도 이벤트 캡처 보장 → 버튼이 네이티브 설치창 띄움.
     Chrome 은 페이지 로드 직후 beforeinstallprompt 를 빨리 쏘므로 최대한 일찍 등록해야 함. */
  window.addEventListener('beforeinstallprompt', function(e){
    e.preventDefault();
    window.__insaDeferredPrompt = e;
    try { if (typeof deferredPrompt !== 'undefined') deferredPrompt = e; } catch(_) {}
  });
  window.addEventListener('appinstalled', function(){
    window.__insaDeferredPrompt = null;
    try { localStorage.setItem('insacheck-a2hs-dismissed', String(Date.now())); } catch(_) {}
  });

  /* v27 사용자 보고 fix: "잠시 후 다시 시도해 주세요" alert 가 떴음 →
     원인: IIFE 의 SW 등록/build 체크 코드에서 에러 발생 시 __insaA2hsShow 정의에 도달 못 함.
     해결: 함수를 IIFE 본체 시작부에 먼저 정의 (다른 코드 실패해도 함수는 살아있음).
     buildBanner / deferredPrompt 는 function 선언/var 로 hoisting + closure 활용. */
  window.__insaA2hsShow = function(){
    try {
      // 이미 설치 → 안내
      var installed = false;
      try {
        if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) installed = true;
        if (window.navigator.standalone === true) installed = true;
      } catch(_) {}
      if (installed) {
        if (window.showToast) window.showToast('이미 앱으로 설치되어 있어요', 'success');
        else alert('이미 앱으로 설치되어 있어요');
        return;
      }
      // 데스크탑 → 스토어 창(worker-pc-sidebar.js · R-200 I) — 토스트·alert 0
      if (!isMobile) {
        if (window.__insStoreSheet) window.__insStoreSheet();
        /* 스토어 창 스크립트가 아직 없으면 아무것도 안 한다(다음 누름에서 열림) — 안내 토스트로 되돌리지 마라. */
        return;
      }
      /* v28 사용자 요청: "바로 설치하게 해줘" — Android 즉시 네이티브 prompt 호출
         - deferredPrompt 가 캡처되어 있으면 buildBanner 의 custom 모달 skip
         - 사이드바 "앱으로 설치" 클릭 → 즉시 prompt() → 네이티브 설치 다이얼로그
         - 사용자 클릭 단계: 사이드바 1번 + 네이티브 prompt "설치" 1번 = 총 2번 (Chrome 정책상 최소) */
      if (isAndroid && !isInApp && window.__insaDeferredPrompt) {
        try {
          var dp = window.__insaDeferredPrompt;
          window.__insaDeferredPrompt = null; // prompt() 는 1회만 호출 가능
          dp.prompt();
          dp.userChoice.then(function(c){
            // 'accepted' → 설치 시작, 'dismissed' → 사용자 거절
            if (c && c.outcome === 'accepted') {
              try { localStorage.setItem('insacheck-a2hs-dismissed', String(Date.now())); } catch(_) {}
            }
          });
          return;
        } catch (e) {
          // prompt() 실패 (이미 호출된 경우 등) — buildBanner fallback
          console.warn('[a2hs] direct prompt failed, fallback to banner:', e);
        }
      }
      // iOS 는 네이티브 prompt API 없음 → buildBanner 의 ios 모달이 최선
      // Android 인데 deferredPrompt 아직 없음 (engagement 미충족) → buildBanner android 모달
      var mode;
      if (isAndroid && !isInApp) mode = 'android';
      else if (isIOS && !isInApp) mode = 'ios';
      else mode = 'inapp';
      var existing = document.getElementById('insacheck-a2hs');
      if (existing) existing.remove();
      if (typeof buildBanner === 'function') {
        buildBanner(mode, true);
      } else {
        // buildBanner 미정의 (IIFE 가 정의 단계 못 감) — 사용자에게 명확한 fallback 안내
        if (isIOS) {
          alert('홈 화면에 추가하려면:\n\n1. 화면 하단 공유 버튼 누르기\n2. "홈 화면에 추가" 선택');
        } else if (isAndroid) {
          alert('홈 화면에 추가하려면:\n\nChrome 우상단 메뉴(⋮) → "홈 화면에 추가" 또는 "앱 설치" 선택');
        } else {
          alert('휴대폰 브라우저에서 같은 주소로 접속 후, 메뉴에서 "홈 화면에 추가" 를 눌러주세요.');
        }
      }
    } catch (e) {
      // 최종 fallback — 어떤 경우에도 사용자에게 명확한 안내
      if (isIOS) {
        alert('Safari 하단 공유 버튼 → "홈 화면에 추가" 를 눌러주세요.');
      } else if (isAndroid) {
        alert('Chrome 우상단 메뉴(⋮) → "홈 화면에 추가" 를 눌러주세요.');
      } else {
        alert('휴대폰 브라우저에서 메뉴 → "홈 화면에 추가" 를 눌러주세요.');
      }
    }
  };

  function isInstalled() {
    try {
      if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) return true;
      if (window.navigator.standalone === true) return true;
    } catch(e){}
    return false;
  }
  function isDismissedRecently() {
    try {
      var d = localStorage.getItem('insacheck-a2hs-dismissed');
      if (d && Date.now() - parseInt(d,10) < 604800000) return true;
    } catch(e){}
    return false;
  }
  // 자동 배너는 모바일 + 미설치 + 미dismiss + 인사책 앱 아닐 때만 · 메일 화면이 떠 있으면 0(R-41 — 자기 시트·서랍을 덮는다 · buildBanner 가 그리는 순간 #ins-wmail 로 판정 · 주소 읽기 0 = W13 면제 지문 그대로 · 수동 설치는 그대로).
  var shouldAutoShow = isMobile && !isInstalled() && !isDismissedRecently() && !isEmbeddedApp;
  /* SW 활성화·빌드 프로브 모두 열린 시트·작성 중 값을 보존한 뒤 갱신한다. */
  var safeReloadTimer = null, lastReloadInteractionAt = 0, navigationLeaving = false, typedFields = typeof WeakSet === 'function' ? new WeakSet() : { add: function(){}, has: function(){ return true; } };   /* typedFields = 사용자가 input 이벤트를 낸 칸(자동완성 포함) — JS 가 value 만 채운 칸은 입력 보호 대상이 아니다(R-233 swr-revalidate #9 · WeakSet 없는 옛 엔진은 종전 판정) */
  ['pointerdown', 'keydown', 'touchmove', 'wheel', 'input', 'scroll'].forEach(function(evName){ try {
    window.addEventListener(evName, function(e){ lastReloadInteractionAt = Date.now(); if (evName === 'input' && e && e.target) typedFields.add(e.target); }, { passive: true, capture: true });
  } catch(_) {} });
  try { window.addEventListener('beforeunload', function(){ navigationLeaving = true; }); } catch(_) {}
  function reloadIsUnsafe(){
    try {
      var active = document.activeElement, fields = document.querySelectorAll('input, textarea');
      if (navigationLeaving || window.__insFragNavBusy === true || Date.now() - lastReloadInteractionAt < 1500) return true;
      if (active && (/^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName || '') || active.isContentEditable || (active.tagName === 'IFRAME' && active.hasAttribute('data-messenger-frame')))) return true;
      if (document.querySelector('dialog[open], [data-sheet-open], .ins-sheet.is-open, .ins-co-sheet:not([hidden]), .fsl-sheet:not([hidden]), .modal.is-open, .ins-dialog-overlay')) return true; /* hidden 여닫이 시트는 ★:not([hidden]) 필수★ — 맨 선택자는 SW 갱신을 영구 차단한다(계약 reload-guard-open-sheets 가 정본) */
      for (var i = 0; i < fields.length; i += 1) {
        var field = fields[i], type = (field.type || '').toLowerCase();
        if (['hidden','checkbox','radio','submit','button'].indexOf(type) < 0 && field.value && field.value !== field.defaultValue && typedFields.has(field)) return true;
      }
    } catch(_) {}
    return false;
  }
  function reloadWhenSafe(delay){
    if (safeReloadTimer) return;
    function attempt(){ safeReloadTimer = null;
      if (reloadIsUnsafe()) { safeReloadTimer = setTimeout(attempt, 700); return; }
      if (lastReloadInteractionAt >= scheduledAt) { window.__insFragSkewNext = 'release'; return; }   /* ★R-233 P6-3★ 예약 뒤 만졌으면 손 뗀 순간 reload 0 — 다음 실제 이동이 통짜로 새 판을 받는다 */ try { var c = navigator.serviceWorker && navigator.serviceWorker.controller; if (c && window.__insQuietReloadMsg) c.postMessage(window.__insQuietReloadMsg); location.reload(); } catch(_) {}
    } var scheduledAt = Date.now(); safeReloadTimer = setTimeout(attempt, delay || 0);
  }
  /* 앱도 SWR 때문에 등록하지만 자동 reload·설치 배너는 끈다. */
  if ('serviceWorker' in navigator) {
    var hadControllerAtStart = false; try { hadControllerAtStart = !!navigator.serviceWorker.controller; } catch(_) {}
    var swUpdateCheckThrottled = function(reg){
      try {
        var k = 'ins:sw_update_at';
        var last = 0;
        try { last = parseInt(localStorage.getItem(k) || '0', 10) || 0; } catch(_) {}
        if (Date.now() - last < 24 * 60 * 60 * 1000) return;
        try { localStorage.setItem(k, String(Date.now())); } catch(_) {}
        try { reg.update(); } catch(_) {}
      } catch(_) {}
    };
    navigator.serviceWorker.register('/sw.js').then(function(reg){
      try {
        // 1일 1회 update 체크 — 새 SW 있으면 install 시작
        swUpdateCheckThrottled(reg);
        // 새 SW 발견 시 즉시 활성화 요청 → activate → SW_ACTIVATED 메시지 → reload
        reg.addEventListener('updatefound', function(){
          var newWorker = reg.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', function(){
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // 기존 SW 가 있는 상태에서 새 SW 가 installed = 업데이트 대기 중. 즉시 적용.
                try { newWorker.postMessage({ type: 'SKIP_WAITING' }); } catch(_) {}
              }
            });
          }
        });

        // 페이지 visibility 변경 시 (탭 복귀 / PWA foreground 복귀) update 또 체크 (스로틀)
        document.addEventListener('visibilitychange', function(){
          if (!document.hidden) swUpdateCheckThrottled(reg);
        });
      } catch(_) {}
    }).catch(function(){});

    /* SW_ACTIVATED → ★갱신(시작 때 controller 있음)만★ 안전 reload · 첫 설치·임베디드는 reload 0 + __insSwTakeoverNoReload 공표 — 시작 값·경위(첫 등록 제외는 처음 의도·미구현이었다): tests/unit/pwa-sw-first-install-no-reload.test.ts */
    var reloadOnce = false; function swActivatedBeacon(v){ try { var p = JSON.stringify({ source: 'client', kind: 'manual', message: 'sw activated (' + v + ')', path: location.pathname, screen: 'sw-activated-' + v }); if (navigator.sendBeacon) navigator.sendBeacon('/api/client-errors', p); else fetch('/api/client-errors', { method: 'POST', body: p, keepalive: true }).catch(function(){}); } catch(_) {} }   /* ★갱신 갈래 결과 비컨★ — reload(세대 다름) · quiet(같은 세대라 안 함) · probe-fail(문의 실패로 reload) · 수집기 규율은 아래 refreshBeacon 과 같다(kind manual = 「기록된다」) · 계약: tests/unit/pwa-sw-first-install-no-reload.test.ts ⓙ */
    navigator.serviceWorker.addEventListener('message', function(ev){
      try {
        if (ev.data && ev.data.type === 'SW_ACTIVATED' && !reloadOnce) {
          reloadOnce = true;
          if (hadControllerAtStart && allowAutomaticReload && !isEmbeddedApp) {
            fetch('/api/build?_ts=' + Date.now(), { method: 'GET', cache: 'no-store', credentials: 'same-origin', headers: { 'X-Build-Probe': '1' } }).then(function(r){ return (r && r.ok) ? r.json() : null; }).then(function(j){ if (compatQuiet(j)) { swActivatedBeacon('quiet'); try { window.__insSwTakeoverNoReload = true; } catch(_) {} } else { swActivatedBeacon(j ? 'reload' : 'probe-fail'); reloadWhenSafe(300); } }, function(){ swActivatedBeacon('probe-fail'); reloadWhenSafe(300); });   // ★S-04 짝★ 배포마다 sw.js 도장이 바뀌어 SW 도 교체된다 — 호환 세대가 같으면 다시 열지 않고 다음 이동 통짜 표식도 0(R-344 · 바뀐 화면만 라우터 skewOf 가 통짜 · 셸은 다음 앱 열기) · 다르거나 칸 없음·실패는 종전 안전 reload(진행 중 fetch·열린 폼이 안전해진 뒤)
          } else { try { window.__insSwTakeoverNoReload = true; } catch(_) {} }
        }
        // SW에는 워커 restore token만 전달한다. 기업 token cache는 즉시 비운다.
        if (ev.data && ev.data.type === 'NEED_TOKEN') {
          try {
            localStorage.removeItem('ins:ent_session_v1');
            var wrkTok = localStorage.getItem('insacheck_session_v1');
            var ctrl = navigator.serviceWorker.controller;
            if (ctrl) {
              ctrl.postMessage({ type: 'CLEAR_TOKEN', kind: 'enterprise' });
              if (wrkTok) ctrl.postMessage({ type: 'SET_TOKEN', kind: 'worker', token: wrkTok });
            }
          } catch(_) {}
        }
        /* v40: v38/v39 NFC_FORWARD 수신부 제거 (2026-08-11 실사고 — sw.js v40 주석 참조).
           forward 된 fetch 가 confirm 화면을 버려 ticket 미소비를 양산했고, 고정 태그
           토큰 dedup 이 재태그를 영원히 무시했다. NFC navigation 은 SW 개입 없이
           서버 confirm 흐름이 처리하며, 구버전 SW 가 보내는 잔여 메시지는 무시한다. */
      } catch(_) {}
    });

    // 페이지 진입 시 워커 token만 SW에 동기하고 기존 기업 cache를 제거한다.
    var syncTokenToSw = function() {
      try {
        var ctrl = navigator.serviceWorker.controller;
        if (!ctrl) return;
        localStorage.removeItem('ins:ent_session_v1');
        var wrkTok = localStorage.getItem('insacheck_session_v1');
        ctrl.postMessage({ type: 'CLEAR_TOKEN', kind: 'enterprise' });
        if (wrkTok) ctrl.postMessage({ type: 'SET_TOKEN', kind: 'worker', token: wrkTok });
      } catch(_) {}
    };
    setTimeout(syncTokenToSw, 100);
    document.addEventListener('visibilitychange', function(){ if (!document.hidden) syncTokenToSw(); }); var clearWorkerSwTokenOnLogout = function(el, attr){ try { var v = el && el.getAttribute && el.getAttribute(attr); if (!v) return; var u = new URL(v, location.href); if (u.origin !== location.origin || u.pathname !== '/auth/logout') return; var c = navigator.serviceWorker.controller; if (c) c.postMessage({ type: 'CLEAR_TOKEN', kind: 'worker' }); } catch(_) {} }; document.addEventListener('click', function(e){ clearWorkerSwTokenOnLogout(e.target && e.target.closest ? e.target.closest('a[href]') : null, 'href'); }, true); document.addEventListener('submit', function(e){ clearWorkerSwTokenOnLogout(e.target, 'action'); }, true);   /* R-219 P18-3 S1 — 로그아웃 링크·폼을 누르는 순간 SW 메모리 근로자 토큰(cachedWorkerToken)을 비운다 · 위 두 CLEAR_TOKEN 은 기업 토큰용(kind:'enterprise')이라 근로자 토큰을 안 지운다 · sw.js 받는 쪽 변경 0 */
  }

  /* 빌드 확인 기록(탭 단위) — 로드 직후 확인은 이 탭이 BUILD_CHECK_FRESH_MS 안에 ★이 문서와 같은 빌드★를 확인했으면
     그 창이 찰 때로 미룬다(다르면 = 낡은 캐시 문서 ⇒ 3초 그대로). 5분 주기 확인은 그대로 돈다. 계약: tests/unit/pwa-app-lifecycle.test.ts
     ★R-922★ 탭 복귀 확인은 이 탭이 60초 안에 ★지금 판과 같은 빌드★를 확인했으면 건너뛴다 — firstBuildCheckDelay 가 240000(=5분−60초)보다 크면 그 뜻(기록 재사용 · 짧은 복귀 반복 = /api/build 0 · 배포 감지 늦어짐 최대 60초). */
  var BUILD_CHECK_FRESH_MS = 300000,   /* 5분(배포 바이트 상한 때문에 리터럴) */ BUILD_CHECK_KEY = 'ins:build_checked';
  function noteBuildChecked(build){ try { sessionStorage.setItem(BUILD_CHECK_KEY, Date.now() + '|' + build); } catch(_) {} }
  function firstBuildCheckDelay(pageBuild){
    try {
      var rec = sessionStorage.getItem(BUILD_CHECK_KEY) || '', cut = rec.indexOf('|');
      var due = (parseInt(rec.slice(0, cut), 10) || 0) + BUILD_CHECK_FRESH_MS - Date.now();
      if (cut > 0 && rec.slice(cut + 1) === pageBuild && due > 3000 && due <= BUILD_CHECK_FRESH_MS) return due;
    } catch(_) {}
    return 3000;
  }
  if (!isEmbeddedApp) {
  /* 배포 감지 — SSR 의 ins-build 메타와 /api/build 가 다르면 안전할 때 강제 reload 1회(sessionStorage 가드로 반복 차단).
     확인 시점: 로드 직후(firstBuildCheckDelay) · 탭 복귀 · 5분 주기(보이는 동안만). */
  try {
    var meta = document.querySelector('meta[name="ins-build"]');
    var currentBuild = meta ? meta.getAttribute('content') : null;
    if (currentBuild) {
      var lastSeen = sessionStorage.getItem('ins:last_build') || '';
      if (lastSeen && lastSeen !== currentBuild) {
        console.log('[ins-build] version changed:', lastSeen, '→', currentBuild);
      }
      sessionStorage.setItem('ins:last_build', currentBuild);

      var checkServerBuild = function() {
        if (document.hidden) return;
        // 가드: 1회 reload 후엔 같은 build 으로 set 되어야 정상. 무한 loop 방지.
        var reloadedFor = sessionStorage.getItem('ins:reloaded_for_build') || '';
        /* /api/build = D1 0회 정적 상수 JSON(ins-build 메타와 같은 값) · _ts 는 SW/중간 캐시 버스터 */
        fetch('/api/build?_ts=' + Date.now(), {
          method: 'GET', cache: 'no-store', credentials: 'same-origin',
          headers: { 'X-Build-Probe': '1' },
        }).then(function(r){ return (r && r.ok) ? r.json() : null; }).then(function(j){
          var serverBuild = j && j.build;
          if (!serverBuild) return; noteBuildChecked(serverBuild);
          if (serverBuild === currentBuild) return; // 동일 — 정상
          if (!allowAutomaticReload || compatQuiet(j)) {   // 플랫폼 관리자 · 호환 세대가 같은 배포(S-04): 쓰던 화면을 강제로 다시 열지 않는다 — SW 만 미리 받아 두고 다음 전체 이동 때 적용(관리자 세션 쿠키는 롤링이라 프로브 인증과 무관).
            console.log('[ins-build] newer build deferred until next navigation:', serverBuild);
            currentBuild = serverBuild;
            sessionStorage.setItem('ins:last_build', serverBuild); if (!compatQuiet(j)) window.__insFragSkewNext = 'release';   /* ★R-344★ 호환 같은 새 판 = 다음 이동 통짜 표식 0(바뀐 화면만 라우터 skewOf 가 통짜 · 사장 10-08 「배포가 건드린 화면만」) · 호환 다른데 자동 reload 가 꺼진 플랫폼 관리자만 다음 조각 이동 1회 통짜 · ★R-233 P6★ 복귀 창 reload 0 · 계약 tests/integration/r272-f1-release-skip-messenger-red.test.ts */
            if (navigator.serviceWorker && navigator.serviceWorker.getRegistration) {
              navigator.serviceWorker.getRegistration().then(function(r){ if (r) r.update(); }).catch(function(){});
            }
            return;
          }
          if (reloadedFor === serverBuild) {
            // 이미 이 build 로 reload 시도했는데 또 mismatch — loop 방지 위해 SW 만 update
            console.warn('[ins-build] already reloaded for', serverBuild, 'but still mismatch — SW update only');
            if (navigator.serviceWorker && navigator.serviceWorker.getRegistration) {
              navigator.serviceWorker.getRegistration().then(function(r){ if (r) r.update(); }).catch(function(){});
            }
            return;
          }
          console.log('[ins-build] server newer:', serverBuild, '(current:', currentBuild + ') — force reload');
          sessionStorage.setItem('ins:reloaded_for_build', serverBuild);
          // SW update 도 동시 trigger
          if (navigator.serviceWorker && navigator.serviceWorker.getRegistration) {
            navigator.serviceWorker.getRegistration().then(function(r){ if (r) r.update(); }).catch(function(){});
          }
          // SW 설치 시간을 주되, 열린 시트·작성 중 입력은 끝까지 보존한다.
          reloadWhenSafe(600);
        }).catch(function(){ /* offline — silent */ });
      };

      setTimeout(checkServerBuild, firstBuildCheckDelay(currentBuild));
      document.addEventListener('visibilitychange', function(){
        if (document.hidden || firstBuildCheckDelay(currentBuild) > 240000) return; setTimeout(checkServerBuild, 500);   /* 복귀 확인(60초 안 같은 판 확인했으면 0 · R-922) — 새 판이 세대가 바뀐 판이면 안전할 때 reload · compatQuiet 판은 reload 0(R-233 P6 · 다음 이동 1회 통짜) */
      });
      setInterval(checkServerBuild, 5 * 60 * 1000);
    }
  } catch(_) {}
  }

  /* ══ §20 — 네이티브 앱 「배포 후 껍데기 강제 1회 갱신」 (2026-08-25, 허브 승인) ══
     설계: docs/workstreams/route-modularization/20-embedded-shell-refresh-design.md
     v62 가 앱에서 끈 것은 「즉시 강제 reload」인데 감지(프로브)까지 함께 꺼지면서,
     앱이 살아 있는 동안(WebView 는 며칠 체류) 새 배포가 셸에 닿을 길이 없어졌다 —
     사장 실기기 「배포해도 옛 화면」 2건/일. 여기서는 ★감지는 켜고, 교체는 안전
     창구에서만★ 한다. 위 브라우저 블록(!isEmbeddedApp)과는 경로를 분리했다 — 전 사용자가
     밟는 자리다. 둘이 공유하는 것은 빌드 확인 기록뿐(계약: tests/unit/pwa-app-lifecycle.test.ts).
     ★Electron 은 계속 제외★ — electron-updater 가 갱신 계약을 이미 갖는다(두 갱신
     기계가 겹치면 서로를 방해한다). isNativeApp(Flutter WebView)만 대상. */
  if (isNativeApp) { (function(){
    /* ★임계값 — 진리가 아니라 관측으로 조정할 값★ (허브 조건 2026-08-25): 아래 관측
       비컨이 창구별 발동을 기록하므로, 분포를 보고 ★여기 한 자리★에서만 조정한다. */
    var RESUME_RELOAD_MIN_HIDDEN_MS = 300000;        /* 복귀 창구 — 이보다 오래 백그라운드였다 돌아오면 사용자 문맥이 이미 끊긴 것으로 본다 */
    var IDLE_RELOAD_AFTER_MS = 180000;               /* 유휴 창구 — 마지막 상호작용 뒤 이만큼 조용하면 교체가 방해가 아니다 */
    var RESUME_WINDOW_MS = 15000;                     /* 복귀 직후 프로브 응답을 기다려 주는 창 */

    var meta = document.querySelector('meta[name="ins-build"]');
    var currentBuild = meta ? meta.getAttribute('content') : null;
    if (!currentBuild) return;
    var shellBuild = currentBuild;   /* 출발판 — 이 페이지가 실제로 실은 판. quiet 갈래가 currentBuild 를 도착판으로 덮어도 비컨은 이 값을 적는다 */
    var staleShellBuild = null;   /* 낡음 표시 — 프로브만 세운다. ★즉시 reload 는 없다★ */
    var lastInteractAt = Date.now();
    var hiddenAt = 0;
    var resumeWindowUntil = 0;

    ['pointerdown', 'keydown', 'touchmove', 'wheel', 'input', 'scroll'].forEach(function(evName){
      try { window.addEventListener(evName, function(){ lastInteractAt = Date.now(); }, { passive: true }); } catch(_) {}
    });

    /* 입력 보호 — 반쯤 쓴 신청서를 지우지 않는다. 이 창구를 건너뛰어도 다음 창구가 온다. */
    function typingNow(){
      try {
        var ae = document.activeElement;
        if (ae && (ae.tagName === 'INPUT' || ae.tagName === 'TEXTAREA' || ae.tagName === 'SELECT' || ae.isContentEditable || (ae.tagName === 'IFRAME' && ae.hasAttribute('data-messenger-frame')))) return true;
        var fields = document.querySelectorAll('input, textarea');
        for (var i = 0; i < fields.length; i += 1) {
          var f = fields[i];
          var t = (f.type || '').toLowerCase();
          if (t === 'hidden' || t === 'checkbox' || t === 'radio' || t === 'submit' || t === 'button') continue;
          if (f.value && f.value !== f.defaultValue && typedFields.has(f)) return true;
        }
      } catch(_) {}
      return false;
    }
    /* 관측 비컨 — ★「보냈다」가 아니라 「기록된다」★ (js-load-rescue 비컨과 같은 규율):
       kind 'manual' 은 client-error 수집기 허용 목록 값이라 'other' 로 접히지 않고,
       본문 스키마는 계약이 buildClientErrorRecord 실물에 먹여 대조한다.
       /api/rum 이 아닌 이유 — perf_samples 는 숫자 전용이라 이 이벤트를 못 싣는다. */
    function refreshBeacon(gate){
      try {
        var payload = JSON.stringify({
          source: 'client',
          kind: 'manual',
          message: 'shell refresh (' + gate + '): ' + shellBuild + ' -> ' + staleShellBuild,
          path: location.pathname,
          screen: 'shell-refresh-' + gate
        });
        if (navigator.sendBeacon) navigator.sendBeacon('/api/client-errors', payload);
        else fetch('/api/client-errors', { method: 'POST', body: payload, keepalive: true }).catch(function(){});
      } catch(_) {}
    }

    function refreshShell(gate){
      try {
        /* 빌드당 1회 — 브라우저 강제 reload 흐름과 같은 키라 이중 발화도 함께 막힌다 */
        try {
          var lastLocal = '';
          try { lastLocal = localStorage.getItem('ins:app_reloaded_for_build') || ''; } catch(_) {}   /* R-344 A4 — 앱 WebView 새 세션(sessionStorage 빔)에서도 같은 판 2회 0 · 둘 중 하나라도 이 판이면 막는다 · localStorage 가 막힌 기기 = 종전 세션 가드 그대로 */
          if (sessionStorage.getItem('ins:reloaded_for_build') === staleShellBuild || lastLocal === staleShellBuild) return;
          sessionStorage.setItem('ins:reloaded_for_build', staleShellBuild);
          try { localStorage.setItem('ins:app_reloaded_for_build', staleShellBuild); } catch(_) {}
        } catch(_) {}
        refreshBeacon(gate); try { sessionStorage.setItem('ins:nav_release', '1'); } catch(_) {}   /* RUM nav_src 'release' — 판 교체로 생긴 전체 이동 */
        /* SWR_QUIET_RELOAD 예고 — SW 가 이 주소의 저장본을 0 왕복으로 준다(프로브는 r.update() 만 한다 · 저장본은 배포 전 판일 수 있다). 그 재검증 「바뀜」의 연속 두 번째 reload 는 ins:swr_qr 표식(아래 조용한 교체의 경로당 60초 가드)이 막는다 */
        try {
          var ctrl = navigator.serviceWorker && navigator.serviceWorker.controller, qrUrl = location.origin + location.pathname + location.search;
          window.__insQuietReloadMsg = { type: 'SWR_QUIET_RELOAD', url: qrUrl }; if (ctrl) ctrl.postMessage(window.__insQuietReloadMsg); sessionStorage.setItem('ins:swr_qr:' + qrUrl.slice(location.origin.length), String(Date.now()));
        } catch(_) {}
        reloadWhenSafe(150);
      } catch(_) {}
    }

    function maybeRefresh(gate){
      if (!staleShellBuild) return;
      if (document.hidden) return;
      if (typingNow()) return;
      refreshShell(gate);
    }

    function probe(){
      if (document.hidden) return;
      fetch('/api/build?_ts=' + Date.now(), {
        method: 'GET', cache: 'no-store', credentials: 'same-origin',
        headers: { 'X-Build-Probe': '1' },
      }).then(function(r){ return (r && r.ok) ? r.json() : null; }).then(function(j){
        var serverBuild = j && j.build;
        if (!serverBuild) return; noteBuildChecked(serverBuild);
        if (serverBuild === currentBuild) return;
        var quiet = compatQuiet(j); if (quiet) currentBuild = serverBuild;   /* 호환 세대 같음(S-04) — 강제 교체 0 · ★R-233 P6★ 복귀·유휴 reload 도 0(다음 실제 이동 1회만 통짜) · 같은 판 재확인은 위 줄에서 끝난다 */
        if (staleShellBuild !== serverBuild) {
          if (!quiet) { staleShellBuild = serverBuild; window.__insFragSkewNext = 'release'; }   /* S04 release — 낡음 표시(복귀·유휴 창구 reload)와 다음 조각 이동 통짜는 ★호환 세대가 바뀐 판에만★(R-344 · 호환 같은 판은 바뀐 화면만 라우터 skewOf 가 통짜 · 셸은 다음 앱 열기) */
          /* SW 업데이트를 먼저 당긴다 — 교체 순간 SWR 캐시가 새 빌드일 확률을 높인다 */
          try {
            if (navigator.serviceWorker && navigator.serviceWorker.getRegistration) {
              navigator.serviceWorker.getRegistration().then(function(r){ if (r) r.update(); }).catch(function(){});
            }
          } catch(_) {}
        }
        /* 복귀 직후 창 안이면 그 자리에서 교체 — 프로브 응답이 늦어도 창구를 놓치지 않게 */
        if (Date.now() < resumeWindowUntil) maybeRefresh('resume');
      }).catch(function(){ /* 오프라인 — 조용히 */ });
    }

    setTimeout(probe, firstBuildCheckDelay(currentBuild));
    setInterval(probe, BUILD_CHECK_FRESH_MS);
    document.addEventListener('visibilitychange', function(){
      if (document.hidden) { hiddenAt = Date.now(); return; }
      var awayMs = hiddenAt ? Date.now() - hiddenAt : 0;
      hiddenAt = 0;
      if (firstBuildCheckDelay(currentBuild) <= 240000) setTimeout(probe, 500);   /* R-922 — 60초 안에 같은 판을 확인했으면 프로브 0 · 숨김 동안은 확인·기록 0 이라 5분+ 떠났다 오면(복귀 창구) 기록이 늘 낡아 늘 친다 */
      if (awayMs >= RESUME_RELOAD_MIN_HIDDEN_MS) {
        resumeWindowUntil = Date.now() + RESUME_WINDOW_MS;
        maybeRefresh('resume');   /* 낡음 표시가 이미 서 있으면 즉시 */
      }
    });
    /* 유휴 창구 — 30초마다 얕은 확인 (document.hidden·낡음 표시 검사뿐이라 비용 0에 가깝다) */
    setInterval(function(){
      if (document.hidden) return;
      if (Date.now() - lastInteractAt >= IDLE_RELOAD_AFTER_MS) maybeRefresh('idle');
    }, 30000);
  })(); }

  var deferredPrompt = null;

  function dismiss(remember){
    var b = document.getElementById('insacheck-a2hs');
    if (b) {
      b.style.transform = 'translateY(100%)';
      b.style.opacity = '0';
      setTimeout(function(){ if(b.parentNode) b.remove(); }, 300);
    }
    if (remember) {
      try { localStorage.setItem('insacheck-a2hs-dismissed', String(Date.now())); } catch(e){}
    }
  }

  function openInBrowser(){
    var url = window.location.href;
    if (isAndroid) {
      // Android Chrome intent — 카카오/인앱에서 Chrome 으로 강제 점프
      window.location.href = 'intent://' + url.replace(/^https?:\/\//,'') + '#Intent;scheme=https;package=com.android.chrome;end';
    } else if (isIOS) {
      // iOS 인앱은 intent 가 없어서 안내만 가능
      alert('우측 상단 메뉴 (또는 "..." 버튼) → "Safari로 열기" 를 눌러주세요');
    }
  }

  function buildBanner(mode, manual){
    if (!manual && document.querySelector && document.querySelector('#ins-wmail:not([hidden])')) return;
    if (!document.body) {
      document.addEventListener('DOMContentLoaded', function(){ buildBanner(mode, manual); });
      return;
    }
    var title, sub, btnLabel, helper = '';
    if (mode === 'android') {
      title = '인사책 앱 설치';
      sub = '홈 화면에 바로 추가됩니다';
      btnLabel = '지금 설치';
    } else if (mode === 'ios') {
      title = 'iPhone 홈 화면에 추가';
      sub = 'Apple 정책상 자동 설치는 불가 — 아래 3단계로 가능합니다';
      btnLabel = '확인했어요';
      /* Apple 은 PWA 자동 설치 prompt API 자체를 제공하지 않는다. iOS Safari 의 유일한 방법 =
         하단 공유 버튼 → "홈 화면에 추가" 라서, 이 3줄은 사용자가 직접 밟아야 하는
         조작 지시다(키오스크 지시문과 같은 부류 — 다이어트 대상 아님).
         2026-08-06 다이어트: 각 단계 밑에 달려 있던 "아이콘 생김새 설명" 두 줄만 제거했다. */
      helper = ''
        + '<div style="background:#f0f9ff;border:1px solid #bae6fd;border-radius:12px;padding:14px;margin-bottom:12px">'
        +   '<div style="display:flex;gap:10px;margin-bottom:10px"><div style="width:24px;height:24px;border-radius:50%;background:#0ea5e9;color:#fff;font-weight:600;font-size:13px;display:flex;align-items:center;justify-content:center;flex-shrink:0">1</div><div style="flex:1;font-size:14px;color:#0c4a6e;line-height:1.5">Safari 하단 <strong>공유</strong> <i class="fas fa-share-square" style="color:#0ea5e9;margin:0 3px"></i></div></div>'
        +   '<div style="display:flex;gap:10px;margin-bottom:10px"><div style="width:24px;height:24px;border-radius:50%;background:#0ea5e9;color:#fff;font-weight:600;font-size:13px;display:flex;align-items:center;justify-content:center;flex-shrink:0">2</div><div style="flex:1;font-size:14px;color:#0c4a6e;line-height:1.5"><strong>"홈 화면에 추가"</strong> <i class="fas fa-plus-square" style="color:#0ea5e9;margin-left:3px"></i></div></div>'
        +   '<div style="display:flex;gap:10px"><div style="width:24px;height:24px;border-radius:50%;background:#0ea5e9;color:#fff;font-weight:600;font-size:13px;display:flex;align-items:center;justify-content:center;flex-shrink:0">3</div><div style="flex:1;font-size:14px;color:#0c4a6e;line-height:1.5">우상단 <strong>"추가"</strong></div></div>'
        + '</div>';
    } else {
      title = isKakao ? '카카오톡 브라우저' : '인앱 브라우저';
      sub = 'Safari/Chrome 에서 열어야 홈 화면에 추가할 수 있어요';
      btnLabel = '기본 브라우저로 열기';
    }

    var html = ''
      + '<div style="width:36px;height:4px;background:#e2e8f0;border-radius:999px;margin:0 auto 14px"></div>'
      + '<button id="a2hs-close" aria-label="닫기" style="position:absolute;top:10px;right:10px;width:32px;height:32px;background:transparent;border:none;color:#475569;cursor:pointer;display:flex;align-items:center;justify-content:center;border-radius:8px"><i class="fas fa-times" style="font-size:14px"></i></button>'
      + '<div style="display:flex;align-items:center;gap:13px;margin-bottom:14px">'
      +   '<img src="/static/icon-192.png?v=20260814-badge-check-wordmark" alt="" style="width:54px;height:54px;border-radius:14px;box-shadow:0 6px 16px rgba(43,116,251,0.32);flex-shrink:0" aria-hidden="true">'
      +   '<div style="flex:1;min-width:0">'
      +     '<div style="font-size:15px;font-weight:700;color:#0f172a;margin-bottom:3px;letter-spacing:-0.2px">' + title + '</div>'
      +     '<div style="font-size:14px;color:#64748b;line-height:1.4">' + sub + '</div>'
      +   '</div>'
      + '</div>'
      + helper
      + '<button id="a2hs-action" style="width:100%;background:linear-gradient(135deg,#4086FF,#2B74FB);border:none;color:#fff;font-weight:600;font-size:14px;padding:13px;border-radius:14px;cursor:pointer;box-shadow:0 4px 14px rgba(43,116,251,0.35);transition:transform 0.15s">' + btnLabel + '</button>';

    var banner = document.createElement('div');
    banner.id = 'insacheck-a2hs';
    banner.style.cssText = 'position:fixed;bottom:var(--app-bottom-obstruction,0px);left:0;right:0;z-index:9990;background:#fff;border-radius:22px 22px 0 0;padding:14px 18px 22px;box-shadow:0 -8px 32px rgba(15,23,42,0.18);transform:translateY(100%);opacity:0;transition:transform 0.35s cubic-bezier(0.34,1.56,0.64,1),opacity 0.25s ease;font-family:var(--font-sans,-apple-system,BlinkMacSystemFont,sans-serif);max-width:520px;margin:0 auto;left:0;right:0';   /* 🚫 bottom:0 금지 — 하단 탭을 덮어 닫기 전 탭이 안 눌린다 · 하단 장애물 정본 = --app-bottom-obstruction(탭바+홈 인디케이터 · 탭 없는 화면은 인디케이터만) */
    banner.innerHTML = html;
    document.body.appendChild(banner);

    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        banner.style.transform = 'translateY(0)';
        banner.style.opacity = '1';
      });
    });

    document.getElementById('a2hs-close').addEventListener('click', function(){ dismiss(true); });
    document.getElementById('a2hs-action').addEventListener('click', function(){
      if (mode === 'android') {
        if (deferredPrompt) {
          deferredPrompt.prompt();
          deferredPrompt.userChoice.then(function(c){
            deferredPrompt = null;
            dismiss(c && c.outcome === 'accepted');
          });
        } else {
          dismiss(false);
        }
      } else if (mode === 'ios') {
        dismiss(true);
      } else {
        openInBrowser();
      }
    });
  }

  // ─── Android: beforeinstallprompt 항상 캡처 (수동 트리거 + 자동 배너 둘 다 사용) ───
  if (isAndroid && !isInApp) {
    window.addEventListener('beforeinstallprompt', function(e){
      e.preventDefault();
      deferredPrompt = e;
      /* v28 사용자 요청 ('바로 설치') — window.__insaA2hsShow 가 즉시 prompt() 호출하려면
         window 전역에도 deferredPrompt 노출. IIFE 시작부 정의된 __insaA2hsShow 가 closure 의
         deferredPrompt 에 접근 못 함 (이 listener 가 나중에 set). 따라서 window 통한 전역 접근. */
      window.__insaDeferredPrompt = e;
      if (shouldAutoShow) setTimeout(function(){ buildBanner('android'); }, 1500);
    });
  } else if (isIOS && !isInApp && shouldAutoShow) {
    setTimeout(function(){ buildBanner('ios'); }, 2500);
  } else if (isInApp && shouldAutoShow) {
    setTimeout(function(){ buildBanner('inapp'); }, 1500);
  }

  // ─── 설치 완료 이벤트 — 배너 자동 닫기 ───
  window.addEventListener('appinstalled', function(){ dismiss(false); });

  /* ══ v62 SWR 클라이언트 (2026-08-12) — public/sw.js v41 과 짝 ══════════════
     사장 지시: "마지막으로 봤던 화면을 0.1초 안에 띄우고 최신값으로 조용히 교체."
     역할:
       ① 캐시로 먼저 그려졌을 때(SWR_SERVED) 상단 2px 진행선 — 재검증 중 표식(글밥 0)
       ② 재검증 결과가 다르면(SWR_REFRESHED changed) ★조용한 교체★ — 단, 사용자가
          아직 화면을 만지지 않았고(스크롤·입력·탭 없음) 착지 10초 안일 때만.
          교체 = SW 에 SWR_QUIET_RELOAD 예고 → location.reload() → SW 가 방금 갱신된
          캐시를 0 왕복 서빙 → 전체 문서가 정상 수명주기로 다시 그려진다(스크립트
          실행 순서 계약·스크롤 복원을 브라우저 기본 동작에 맡긴다 — DOM 부분 교체는
          화면 JS 재초기화 계약이 없어 위험). 만졌거나 10초가 지났으면 ★보는 중 reload 0★ — 숨김→보임 때 1회 또는 다음 이동(관제실 D-R2).
       ③ 재검증 실패(DB 못 받음·오프라인, SWR_REFRESH_FAILED) — 「n초 전 기준」 칩(성공 재검증까지 유지 · R-763)
       ④ 세션 만료·계정 전환(SWR_STALE_AUTH) — 즉시 전체 새로고침(로그인으로 착지)
       ⑤ 유휴 워밍 ★세션 1회★ — 하단바 탭 URL 을 ★실제 렌더된 DOM 링크★ 에서 읽어 SW 에 SWR_WARM 으로
          전달(조각 프라이밍이 받는 화면은 뺀다). 기록 화면에서는 플랫 탭(?tab=) 링크도 함께.
          SW 쪽에서 allowlist 재검증 + 2분 신선 항목 스킵.
       ⑥ 로그인 화면 진입 시 SWR_PURGE 벨트 — SW 관찰(퍼지 방아쇠)과 이중 안전장치.
     ★마크업 불변★ — 이 블록은 자기 요소(진행선·문구)만 만들고 화면 DOM 을 바꾸지 않는다. */
  if ('serviceWorker' in navigator) { (function(){
    var swrPath = location.pathname;
    // ⑥ 로그인 화면 = 계정 전환 길목 — 선제 퍼지 벨트
    if (swrPath === '/login' || swrPath === '/admin/login') {
      try {
        var purgeCtrl = navigator.serviceWorker.controller;
        if (purgeCtrl) purgeCtrl.postMessage({ type: 'SWR_PURGE' });
      } catch(_) {} try { if (isNativeApp && !sessionStorage.getItem('ins:cold_seen')) { sessionStorage.setItem('ins:cold_seen', '1'); if (sessionStorage.getItem('ins:cold_seen') === '1') { var cm = /(?:^|;\s*)app_ver=([^;]{1,40})/.exec(document.cookie || ''), av = cm ? cm[1] : ''; try { av = decodeURIComponent(av); } catch(_) {} navigator.sendBeacon('/api/rum', JSON.stringify({ route: swrPath, is_app: 1, phase: 'cold', cold: /[?&]msg=/.test(location.search) ? 'login' : 'login_start', app_ver: av.replace(/[^A-Za-z0-9.\-_+]/g, '').slice(0, 40) || null, platform: isAndroid ? 'android' : isIOS ? 'ios' : 'web' })); } } } catch(_) {}   /* R-233 ⓑ 냉기동 첫 문서가 로그인 화면이면 phase cold 비콘 1개(앱 · 세션 첫 문서만 · 표식 ins:cold_seen · msg= 있음 = 보호 화면에서 튕김 login / 없음 = login_start · 쿼리 글자·토큰·id 는 보내지 않는다 · 저장소 막힘 = 안 보냄) */
      return;
    }
    // SWR 대상 화면(하단바 4탭)이 아니면 워밍만 스케줄한다 (다른 /worker 화면에서도
    // 탭 캐시를 데워 두면 다음 탭 이동이 0 왕복이 된다).
    var SWR_TAB_PATHS = ['/worker/dashboard', '/worker/requests', '/worker/history', '/worker/schedule'];
    /* ★관리자 축 SWR 수신부 (2026-09-01)★ — 아래 return 때문에 /admin 에는 수신부가
       ★하나도 없었다★. sw.js 의 B안 주석이 방어층 ②로 「SWR_STALE_AUTH → 즉시 새로고침」을
       근거로 인용하는데 ★그 방어가 이 축에서만 비어 있었다.★ 그 하나만 메운다 —
       진행선·조용한 교체는 ★일부러 제외★(편집 폼 유실). 계약: pwa-swr-client ⑤⑥. */
    /* 출근 피크(KST 08:30~09:10) — 경계 착지 예열(S-05ⓑ)을 끈다(피크 D1 보호 · 관제실 2026-10-02) */
    var insWarmPeak = function(){ try { var p = new Intl.DateTimeFormat('en-GB', { timeZone: /*t:TZ*/'Asia/Seoul'/*t*/, hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date(Date.now())), h = 0, mi = 0; for (var i = 0; i < p.length; i++) { if (p[i].type === 'hour') h = +p[i].value; else if (p[i].type === 'minute') mi = +p[i].value; } var m = h * 60 + mi; return m >= 510 && m < 550; } catch(_) { return false; } };   /* KST 08:30~09:10 — 시간대는 Intl(Asia/Seoul)이 정한다(손 오프셋 금지 · stored-clock-column-audit ③-b) */
    /* ③ 재검증 실패 = 저장본을 보여 주는 중 — 「n초 전 기준」 (R-763 · 사장 2026-10-24) · 사본(문서·데이터 API)마다 실패 시각을 들고
       가장 오래된 것을 10초마다 다시 센다 · 그 사본의 재검증이 성공하면 지운다(전부 지워지면 칩도 사라진다) · 관리자 축도 같은 칩. */
    var staleK = {}, staleTimer = 0;
    function showLastChecked(k, at){
      try {
        if (at) staleK[k] = at; else delete staleK[k];
        var min = 0, c = document.getElementById('ins-swr-stale'), s;
        for (var x in staleK) if (!min || staleK[x] < min) min = staleK[x];
        if (!min) { clearInterval(staleTimer); staleTimer = 0; if (c) c.remove(); return; }
        if (!c && document.body) { c = document.createElement('div'); c.id = 'ins-swr-stale'; c.setAttribute('role', 'status');
          c.style.cssText = 'position:fixed;top:8px;left:50%;transform:translateX(-50%);z-index:9991;background:rgba(15,23,42,.78);color:#f1f5f9;font-size:11px;padding:5px 9px;border-radius:999px;pointer-events:none';
          document.body.appendChild(c); }
        s = (Date.now() - min) / 1000 | 0;
        if (c) c.textContent = (s < 60 ? s + '초' : s < 3600 ? (s / 60 | 0) + '분' : (s / 3600 | 0) + '시간') + ' 전 기준';
        if (!staleTimer) staleTimer = setInterval(showLastChecked, 10000, '');   /* 다시 세기만(빈 키 = 지울 것 없음) */
      } catch(_) {}
    }
    var swrStaleMsg = function(d){ if (d.type.indexOf('SWR_REFRESH') === 0 && d.url && (d.url === location.origin + location.pathname + location.search || d.url.indexOf('/api/') > 0)) showLastChecked(d.url, d.cachedAt); };   /* 지금 화면 문서 + 그 화면이 받은 데이터 API(SW 는 요청한 창에만 보낸다) · cachedAt 은 실패 통지에만 실린다(성공 = 칩에서 뺌) · 실패 통지에 시각이 없으면(옛 빌드 사본) 나이를 모르므로 칩에 넣지 않는다 */
    if (swrPath.indexOf('/admin') === 0) {
      var adminStaleOnce = false;
      try {
        navigator.serviceWorker.addEventListener('message', function(ev){
          try { var d = ev.data || {}; swrStaleMsg(d); if (d.type !== 'SWR_STALE_AUTH' || adminStaleOnce || (d.url && d.url !== location.origin + location.pathname + location.search)) return; adminStaleOnce = true; location.reload();   /* 그 문서 키의 권한 상실만 통째 reload(R-233 data-stores #7) — 다른 사본(API 등)의 상실은 그 사본 삭제로 끝 · 권한 회수는 이 문서 재검증이 같은 신호를 낸다 */ } catch(_) {}
        });
      } catch(_) {}
      /* ★「내 업무」 착지 예열 (S-05ⓑ)★ — 그 탭이 ★직행(/worker/*)으로 그려진 사람★ 에게만 · 한가할 때 · 세션 1회 · 출근 피크 끔. 저장 판정은 SW 몫(표식 없으면 0 · 쓰기 GET 0). 계약: pwa-swr-client. */
      var warmWorker = function(){ setTimeout(function(){ (window.requestIdleCallback || setTimeout)(function(){ try { var t = document.querySelector('#ent-desktop-worker-role-tab:not(.hidden)'), h = (t && t.getAttribute('href')) || '', ctl = navigator.serviceWorker.controller; if (!ctl || document.hidden || insWarmPeak() || h.indexOf('/worker/') !== 0 || sessionStorage.getItem('ins-swr-warmed-a')) return; sessionStorage.setItem('ins-swr-warmed-a', '1'); ctl.postMessage({ type: 'SWR_WARM', urls: [new URL(h, location.href).href] }); } catch(_) {} }, { timeout: 4000 }); }, 2000); };
      if (document.readyState === 'complete') warmWorker(); else window.addEventListener('load', warmWorker);
      return;
    }
    if (swrPath.indexOf('/worker') !== 0) return;

    var pageKey = location.origin + location.pathname + location.search;
    var landedAt = Date.now(), touchSeq = 0, swrPending = false, resumedAt = 0, resumeSeq = -1, swrHiddenAt = 0;   /* touchSeq = 착지 뒤 접촉 수(스크롤 포함) · swrPending = 보는 중에 미룬 「바뀜」(숨김→보임 때 1회 교체 · 미룰 때마다 localStorage ins:swr_defer=1 → 다음 load 비콘 swr_defer · R-233 D 계기 · 미룸 동작 무변) · resume* = 숨김 ≥60초 복귀 시각·그때 접촉 수 */
    ['pointerdown', 'keydown', 'touchmove', 'wheel', 'input', 'scroll'].forEach(function(evName){
      try { window.addEventListener(evName, function(){ touchSeq += 1; }, { passive: true }); } catch(_) {}
    });

    // ① 미세 진행선 — 재검증이 도는 동안만 존재한다
    var bar = null;
    function showBar(){
      try {
        if (bar || !document.body) return;
        bar = document.createElement('div');
        bar.id = 'ins-swr-bar';
        bar.setAttribute('aria-hidden', 'true');
        bar.style.cssText = 'position:fixed;top:0;left:0;height:2px;width:30%;z-index:9991;'
          + 'background:linear-gradient(90deg,rgba(64,134,255,0),#4086FF,rgba(64,134,255,0));'
          + 'pointer-events:none;transition:opacity .3s ease;opacity:.85;transform:translateX(-100%)';
        document.body.appendChild(bar);
        var pos = -100;
        bar.__insTimer = setInterval(function(){
          pos = pos >= 340 ? -100 : pos + 12;
          try { bar.style.transform = 'translateX(' + pos + '%)'; } catch(_) {}
        }, 40);
      } catch(_) {}
    }
    function hideBar(){
      try {
        if (!bar) return;
        var b = bar; bar = null;
        if (b.__insTimer) clearInterval(b.__insTimer);
        b.style.opacity = '0';
        setTimeout(function(){ try { if (b.parentNode) b.remove(); } catch(_) {} }, 350);
      } catch(_) {}
    }

    // ② 조용한 교체 — 착지(또는 숨김 ≥60초 복귀) 10초 안 · 무접촉이면 지금(랜딩의 일부). 그 밖의 「바뀜」은 ★보는 중 reload 0★ → 미뤘다가 숨김→보임(back) 때 1회 · 경로당 60초 1회(교체 루프 차단)
    function maybeQuietReload(back){
      try {
        /* 조각 전환 뒤에는 출발 문서의 늦은 재검증으로 현재 화면을 reload 하지 않는다(다음 이동이 새 문서를 받는다). */
        if (location.origin + location.pathname + location.search !== pageKey) return;
        var fresh = (touchSeq === 0 && Date.now() - landedAt <= 10000) || (touchSeq === resumeSeq && Date.now() - resumedAt <= 10000);   /* 숨김 ≥60초 복귀도 착지처럼 잰다(복귀 시각 기준 10초 · 그 뒤 무접촉) */
        if (!back && !fresh && document.querySelector('[data-ins-frag-root]') && typeof window.__insFragRecheck === 'function') { window.__insFragRecheck(); return; }   /* 조각 루트 화면 = 조각 재검증으로 넘긴다(미룸·스크롤 유지 교체는 frag-quiet-replace.js 몫) */
        if ((!back && !fresh) || reloadIsUnsafe()) { swrPending = true; try { localStorage.setItem('ins:swr_defer', '1'); } catch(_) {} return; }
        var gk = 'ins:swr_qr:' + location.pathname + location.search;
        var last = 0;
        try { last = parseInt(sessionStorage.getItem(gk) || '0', 10) || 0; } catch(_) {}
        if (Date.now() - last < 60000) return;
        swrPending = false; try { sessionStorage.setItem(gk, String(Date.now())); } catch(_) {}
        var ctrl = navigator.serviceWorker.controller;
        if (ctrl) { try { ctrl.postMessage({ type: 'SWR_QUIET_RELOAD', url: pageKey }); } catch(_) {} }
        quietReloadWithFade();
      } catch(_) {}
    }
    /* ★교체를 「두 번 랜딩」으로 보이지 않게 한다★ — reload ★직전★ 130ms 흐림(밝기가 잠깐 내려간 한 화면으로 읽힌다 · 사장 신고 2026-08-18 B안).
       ⚠️ ★캐시를 끄거나 reload 를 없애지 마라★ — 사장이 만든 속도 개선을 되돌린다. 바꾸는 것은 ★보이는 방식★ 하나다.
       ⚠️ prefers-reduced-motion 이면 즉시 교체. ⚠️ 페이드가 안 끝나도 ★반드시 reload★(타이머 + 폴백) — 흐린 채 멈춤이 가장 나쁘다. */
    function quietReloadWithFade(){
      var root, seq = touchSeq;
      var go = function(){ try { if (touchSeq !== seq || location.origin + location.pathname + location.search !== pageKey || reloadIsUnsafe()) { if (root && root.style) root.style.opacity = ''; swrPending = true; try { localStorage.setItem('ins:swr_defer', '1'); } catch(_) {} return; } location.reload(); } catch(_) {} };   /* 흐림 사이 만졌으면 취소하고 미룸 */
      try {
        var reduce = false;
        try {
          reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        } catch(_) {}
        root = document.documentElement;
        if (reduce || !root || !root.style) { go(); return; }
        root.style.transition = 'opacity 120ms ease-out';
        root.style.opacity = '0.55';
        /* 전환이 시작될 틈만 주고 바로 간다 — 길게 끌면 그 자체가 느려 보인다. */
        setTimeout(go, 130);
      } catch(_) { go(); }
    }

    var staleAuthOnce = false;
    navigator.serviceWorker.addEventListener('message', function(ev){
      try {
        var d = ev.data || {}; swrStaleMsg(d);
        if (d.url && d.url !== pageKey) return;
        if (d.type === 'SWR_SERVED') { showBar(); return; }
        if (d.type.indexOf('SWR_REFRESH') === 0) {   /* 성공·실패 둘 다 진행선을 닫는다 — 실패의 칩은 위 swrStaleMsg 몫 · 실패 통지엔 changed 가 없다 */
          hideBar();
          if (d.changed) maybeQuietReload();
          return;
        }
        if (d.type === 'SWR_STALE_AUTH' && !staleAuthOnce) {
          staleAuthOnce = true;
          hideBar();
          try { location.reload(); } catch(_) {}
        }
      } catch(_) {}
    });
    document.addEventListener('visibilitychange', function(){ try {   /* 숨김→보임 = 미룬 「바뀜」 교체 1회(D-R2 · 입력 보호·60초 가드 그대로 — 막히면 다음 숨김→보임) */
      if (document.hidden) { swrHiddenAt = Date.now(); return; } var away = swrHiddenAt ? Date.now() - swrHiddenAt : 0; swrHiddenAt = 0;
      if (swrPending) { maybeQuietReload(1); return; }
      if (away < 60000) return; resumedAt = Date.now(); resumeSeq = touchSeq;   /* 60000 = frag-quiet-replace.js RECHECK_HIDDEN_MS 와 같은 값 */
      var c = navigator.serviceWorker.controller; if (c && typeof window.__insFragRecheck !== 'function') c.postMessage({ type: 'SWR_REVALIDATE_CURRENT', url: pageKey, frag: false });   /* 지금 문서 재검증 1회 — 조각 라우터 화면은 frag-quiet-replace.js 가 보낸다 · 결과는 SWR_REFRESHED 길 */
    } catch(_) {} });

    // ⑤ 유휴 워밍 — 실제 DOM 링크에서 대상 URL 수집 (게이팅·권한 반영본)
    function collectWarmUrls(){
      var urls = [];
      /* ★조각 프라이밍이 조각 키로 받는 주소는 문서 키로 또 데우지 않는다★ — 탭 이동은 조각 키만 읽는다(sw.js swrHandleFragment).
         목록은 shell-frag-prime.js 가 이 세션에 공표한 그것 하나(사본 0) · 공표가 없으면(프라이밍이 안 돌았다) 종전대로 다 데운다. */
      var fragPrimed = [];
      try { fragPrimed = (sessionStorage.getItem('ins-frag-prime-targets') || '').split(','); } catch(_) {}
      var push = function(href){
        try {
          var u = new URL(href, location.href);
          if (u.origin !== location.origin) return;
          if (SWR_TAB_PATHS.indexOf(u.pathname) < 0 || fragPrimed.indexOf(u.pathname + u.search) >= 0) return;
          var key = u.origin + u.pathname + u.search;
          if (urls.indexOf(key) < 0) urls.push(key);
        } catch(_) {}
      };
      try {
        var tabs = document.querySelectorAll('#worker-mobile-bottom-nav a[href]');
        for (var i = 0; i < tabs.length; i++) push(tabs[i].getAttribute('href'));
      } catch(_) {}
      if (location.pathname === '/worker/history') {
        try {
          // 기록 플랫 탭(?tab=) — 기록 화면에 있을 때만 데운다 (다른 화면에서 전 탭
          // 워밍은 LAX 왕복 낭비 — 서버 렌더 비용이 실재한다)
          var flats = document.querySelectorAll('a[href^="/worker/history?"]');
          for (var j = 0; j < flats.length && j < 12; j++) push(flats[j].getAttribute('href'));
        } catch(_) {}
      }
      if (!(location.pathname === '/worker/requests' && /[?&]type=/.test(location.search) && /[?&]id=/.test(location.search))) push(pageKey); /* ★결재 상세는 워밍 대상이 아니다(D-6)★ — 근거·대조군은 tests/integration/request-landing-correctness-set.test.ts 머리말이 정본 */
      /* ★회사관리 목적지 예열★ — 회사관리 문은 통짜 문서로만 닿는다(조각 제외를 걸지 않는다). ① 브릿지 문(enter-admin · 세션 발급 쓰기 + 302)은
         🚫 게이트는 데우지 않고 ★착지 문서만★(next) 데운다(302 착지 캐시 키 = 워밍 키). ② ★직행 문(door=worker · adminBridgeHref)★ 은 그 주소가 곧 착지 키다 —
         회수 세션이면 302 라 SW 가 redirect:'manual' 로 저장 0·브릿지 미실행(S-05ⓑ) · 출근 피크엔 끈다. 🚫 ★긍정 표식 data-ins-warm-admin 만 집는다★(문서 순서로 집지 마라 — 사연은 계약 머리말). 상한은 ★서로 다른 목적지 2★. 계약: pwa-swr-client. */
      try {
        var adminLinks = document.querySelectorAll('a[data-ins-warm-admin]'), peak = insWarmPeak();
        for (var k = 0, taken = 0; k < adminLinks.length && taken < 2; k++) {
          var ah = adminLinks[k].getAttribute('href') || '', au = new URL(ah, location.href);
          var nx = ah.indexOf('/worker/enter-admin?') === 0 ? au.searchParams.get('next') : (!peak && au.pathname.indexOf('/admin/') === 0 && au.searchParams.get('door') === 'worker' ? ah : '');
          if (!nx || nx.charAt(0) !== '/' || nx.charAt(1) === '/') continue;   /* 같은 출처 절대경로만(열린 리다이렉트 방지와 같은 검사) */
          var du = new URL(nx, location.href);
          if (du.origin !== location.origin) continue;
          var dkey = du.origin + du.pathname + du.search;
          if (urls.indexOf(dkey) < 0) { urls.push(dkey); taken++; }
        }
      } catch(_) {}
      /* ★데이터 워밍 (3-A2)★ — 신청 센터 집계 JSON 을 문서 ★뒤★에 붙인다(SW 워밍 큐는 순서대로 순차 실행 · 표식 없으면 저장 0 = fail-closed).
         🚫 ★홈 번들(dashboard-bundle)은 데우지 않는다★ — 그 GET 이 회사 전체 미퇴근 자동보강을 돌려 ★사용자가 안 눌렀는데 서버 상태가
         바뀐다★(자동보강은 제품 기능이라 그대로 · 부르는 자리만 없앴다 · 실제 방문이 채우고 캐시 등재는 유지).
         원장·계약: swr-policy.ts SWR_WRITE_GET_PATHS · tests/contracts/swr-warm-no-write-get.test.ts */
      /* 화면이 스스로 부른 질의는 빼고 데운다 — 계약 request-center-list-query-count (V2-0 R-1) */
      try { if ((window.__insWarmSkip || {})['/api/worker/my-requests']) return urls; } catch(_) {} urls.push(location.origin + '/api/worker/my-requests');
      return urls;
    }
    function scheduleWarm(){
      var fire = function(){
        try {
          if (document.hidden) return;
          var ctrl = navigator.serviceWorker.controller;
          if (!ctrl) return;
          if (sessionStorage.getItem('ins-swr-warmed')) return;   /* ★세션 1회★ — shell-frag-prime.js Ⓐ 와 같은 뜻(통짜 로드마다 데우지 않는다) */
          var urls = collectWarmUrls();
          if (!urls.length) return;
          sessionStorage.setItem('ins-swr-warmed', '1');   /* 실제로 보낼 때만 칸을 쓴다 — 숨은 탭·컨트롤러 없음은 세션을 소비하지 않는다 */
          ctrl.postMessage({ type: 'SWR_WARM', urls: urls });
        } catch(_) {}
      };
      try {
        if (typeof requestIdleCallback === 'function') {
          setTimeout(function(){ requestIdleCallback(fire, { timeout: 4000 }); }, 2000);
        } else {
          setTimeout(fire, 3500);
        }
      } catch(_) { setTimeout(fire, 3500); }
    }
    if (document.readyState === 'complete') scheduleWarm();
    else window.addEventListener('load', scheduleWarm);
  })(); }

  /* 🚫 ★__insaA2hsShow 를 여기서 다시 정의하지 마라★ — 파일 머리(IIFE 시작부)의 정의(Android 네이티브 prompt() 우선)를 덮어
     「앱으로 설치」가 설치창 대신 배너만 띄우는 회귀가 났다(v61). Android 캡처 리스너·자동배너는 위에 그대로 둔다. */
})();
